export const MAX_SHARE_COPY_COUNT = 5;
export const ACTIVE_THUMBNAIL_COUNT = 5;
